import React from "react";
import TopBannar from "./TopBannar/TopBannar";
import ClientsAndMarkets from "./ClientsAndMarkets/ClientsAndMarkets";
import Progess from "./Progess/Progess";
import Incorporate from "./Incorporate/Incorporate";
import InvestingFoundation from "./InvestingFoundation/InvestingFoundation";
import GetStarted from "./GetStarted/GetStarted";
import WhyChoose from "./WhyChoose/WhyChoose";
import InstantAccess from "./InstantAccess/InstantAccess";
import AllYourInvestments from "./AllYourInvestments/AllYourInvestments";
import AccountSafely from "./AccountSafely/AccountSafely";
import TradingAccounts from "./TradingAccounts/TradingAccounts";
import CryptoXStocks from "./CryptoXStocks/CryptoXStocks";
import { isMobile } from "react-device-detect";
import DesktopTopBannar from "./Desktop/DesktopTopBannar/DesktopTopBannar";
import DesktopClientsAndMarkets from "./Desktop/DesktopClientsAndMarkets/ClientsAndMarkets";
import DesktopProgess from "./Desktop/DesktopProgess/Progess";
import DesktopIncorporate from "./Desktop/DesktopIncorporate/Incorporate";
import DesktopWhyChoose from "./Desktop/DesktopWhyChoose/WhyChoose";
const Home = () => {
  // Desktop
  if (isMobile) {
    return (
      <>
        <TopBannar />
        <ClientsAndMarkets />
        <Progess />
        <Incorporate />
        <WhyChoose />
        <AllYourInvestments />
        <AccountSafely />
        <TradingAccounts />
        <CryptoXStocks />
        {/* <InvestingFoundation />
      <GetStarted />
      <InstantAccess /> */}
      </>
    );
  } else {
    return (
      <>
        <DesktopTopBannar />
        <DesktopClientsAndMarkets />
        <DesktopProgess />
        <DesktopIncorporate />
        <DesktopWhyChoose />
        <AllYourInvestments />
        <AccountSafely />
        <TradingAccounts />
        <CryptoXStocks />
      </>
    );
  }
};

export default Home;
